<template>
  <div class="dialog-wrap">
    <el-dialog title="调剂信息"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               :modal-append-to-body="false"
               @open="open"
               width="80%">
      <div class="values">
        <div style="display:flex;justify-content: space-between; min-height:70px">
          <el-form class="search-wrap"
                   ref="searchForm"
                   :inline="true"
                   :model="query">
            <el-form-item label="年份"
                          prop="year">
              <el-select v-model="year"
                         clearable
                         style="width:90px;marginLeft:10px"
                         placeholder="请选择"
                         @change="fetchList(true)">
                <el-option label="2027年"
                           value="2027"></el-option>
                <el-option label="2026年"
                           value="2026"></el-option>
                <el-option label="2025年"
                           value="2025"></el-option>
                <el-option label="2024年"
                           value="2024"></el-option>
                <el-option label="2023年"
                           value="2023"></el-option>
                <el-option label="2022年"
                           value="2022"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="院校名称"
                          prop="college_name">
              <el-select v-model="college_keyword"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         clearable
                         @change="fetchList(true)">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学院"
                          prop="reamrk">
              <el-select v-model="apply_academy"
                         placeholder="请选择院校"
                         clearable
                         filterable
                         @change="academyChange"
                         style="width: 100%;">
                <el-option v-for="(item,index) in academyList"
                           :key="index"
                           :label="`（${item.code}）${item.name}`"
                           :value="{ value: item.code, label: item.name}">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业"
                          prop="reamrk">
              <el-select v-model="apply_major"
                         placeholder="请选择专业"
                         clearable
                         filterable
                         @change="majorChange"
                         style="width: 100%;">
                <el-option v-for="(item,index) in majorList"
                           :key="index"
                           :label="`（${item.code}）${item.name}`"
                           :value="{ value: item.code, label: item.name}">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="query._deletes"
                         placeholder="请选择"
                         @change="fetchList(true)"
                         clearable>
                <el-option v-for="item in filter.delete_types"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div style="display:flex; height:30px">
            <div class="btBox">
              <el-button plain
                         style="marginRight:20px"
                         @click="handleDownload"
                         type="primary">下载模板</el-button>
              <input @change="upload"
                     type="file"
                     name="photoImg"
                     id="getFile"
                     style="display:none;"
                     class="upload-input" />
              <label for="getFile"
                     class="fileStyle">导入</label>

            </div>
            <el-button class="button"
                       @click="adjustAdd"
                       type="primary">新建</el-button>
          </div>
        </div>
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           fixed="left"
                           align="center"></el-table-column>

          <el-table-column label="年份"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.year }}年考研
            </template>
          </el-table-column>
          <el-table-column prop="college_name"
                           label="院校名称"
                           align="center"
                           show-overflow-tooltip
                           width="120px">
          </el-table-column>
          <el-table-column label="专业名称"
                           align="center"
                           width="200px"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              [{{ scope.row.major_code }}]{{ scope.row.major_name }}
            </template>
          </el-table-column>
          <el-table-column label="学院名称"
                           width="200px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              ({{ scope.row.academy_code }}){{ scope.row.academy_name }}
            </template>
          </el-table-column>
          <el-table-column label="方向名称"
                           width="200px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              ({{ scope.row.direction_code }}){{ scope.row.direction_name }}
            </template>
          </el-table-column>
          <el-table-column label="学习方式"
                           width="90px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.enrol_type == 2 ? "非全日制" : "全日制"}}
            </template>
          </el-table-column>
          <el-table-column prop="plan_last_count"
                           label="调剂余额"
                           width="90px"
                           align="center"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="上下线状态"
                           width="90px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :type="scope.row._delete==0?'success':'info'">
                {{scope.row._delete==0?'上线':'下线'}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="搜集人"
                           width="90px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.creator?scope.row.creator.nickname:''}}
            </template>
          </el-table-column>
          <el-table-column label="更新日期"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.update_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建日期"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToEdit(scope.row)">编辑</el-link>
              <el-link type="danger"
                       :underline="false"
                       @click="handleToRemove(scope.row.id)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
      <InformationCreate :visible="createDialog"
                         :detail="detail"
                         @close="createDialog=false"
                         @submit="fetchList"></InformationCreate>
      <InformationEdit :visible="editDialog"
                       @close="editDialog=false"
                       :detail="detail"
                       :id="editId"
                       @submit="submitFetchList"></InformationEdit>
    </el-dialog>
  </div>
</template>

<script>
import InformationCreate from '@/components/dialog/admission/addAdjust'
import InformationEdit from '@/components/dialog/admission/editAdjust.vue'
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
import { adjustAdminlist, deleteAdjustAdmin } from '@/api/adjust'
import { adjustInfolmport } from '@/api/admission'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    adjustDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    year: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    adjustDetail(val) {
      console.log('val', val)
      this.detail = val
      this.$set(this.apply_major, 'value', val.major_code)
      this.college_keyword = val.college_code
    },
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf()
        this.query.end_create_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.start_create_time = ''
        this.query.end_create_time = ''
        this.fetchList(true)
      }
    },
  },
  components: {
    InformationCreate,
    InformationEdit,
  },
  data() {
    return {
      detail: {},
      senior: {},
      directionList: [],
      dialogVisible: false,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        year: this.year,
      },
      pageTotal: 10,
      results: [],
      chooseList: [],
      majorList: [],
      academyList: [],
      apply_major: { value: '', label: '' },
      apply_academy: {},
      createDialog: false,
      editDialog: false,
      editId: null,
      filter: {
        years: [
          { label: '2027年考研', value: 2027 },
          { label: '2026年考研', value: 2026 },
          { label: '2025年考研', value: 2025 },
          { label: '2024年考研', value: 2024 },
          { label: '2023年考研', value: 2023 },
        ],
        enrol_types: [
          { label: '全日制', value: 1 },
          { label: '非全日制', value: 2 },
        ],
        delete_types: [
          { label: '上线', value: 0 },
          { label: '下线', value: 2 },
        ],
      },
      college_keyword: '',
    }
  },

  methods: {
    academyChange() {
      console.log('ac', this.apply_academy)
      this.fetchList(true)
    },
    majorChange() {
      console.log('ma', this.apply_major)
      this.fetchList(true)
    },
    // 专业
    Majorists() {
      collegeMajorList({
        college_code: this.detail.college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list
      })
    },
    // 院校
    getAcademyList() {
      academyList({
        college_code: this.detail.college_code,
        isPaging: 0,
      }).then((res) => {
        this.academyList = res.list
      })
    },

    handleDownload() {
      let url =
        'https://upload.kaoyanbox.net/3694d1700df5c869326942ba874c0b89.xlsx'
      let filename = '调剂名单文件导入示例文件.xlsx'
      var ajax = new XMLHttpRequest()
      ajax.open('GET', url, true)
      ajax.responseType = 'blob'
      ajax.onload = (e) => {
        let res = e.target.response
        let blob = new Blob([res], { type: res.type }) // 这里的res为后端返回的流数据
        if (window.navigator.msSaveOrOpenBlob) {
          //兼容IE10
          navigator.msSaveBlob(blob, filename)
        } else {
          const href = URL.createObjectURL(blob) //创建新的URL表⽰指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载链接
          a.download = filename //指定下载⽂件名
          a.click() //触发下载
          URL.revokeObjectURL(a.href) //释放URL对象
        }
      }
      ajax.send()
    },

    // 录取方向
    majorDirect(college_code, major_code) {
      majorinfo({
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }).then((res) => {
        if (res.academys && res.academys.length) {
          let list = res.academys.map((item) => item.directions).flat()
          let obj = {}
          for (let item of list) {
            if (!obj[item.direction_code]) {
              obj[item.direction_code] = item
            }
          }
          this.directionList = Object.values(obj)
        }
      })
    },
    submitFetchList() {
      this.fetchList()
    },
    upload(e) {
      const file = e.target.files[0]
      if (file) {
        /******  此处为上传服务器 start   ******/
        let formData = new FormData()
        formData.append('file', file)
        adjustInfolmport(formData).then((res) => {
          console.log('res', res)
          if (res == null) {
            this.$message.success(`导入成功`)
            this.fetchList(true)
          }
        })
      }
    },
    adjustAdd() {
      this.createDialog = true
    },
    handleClose() {
      this.apply_major = {}
      this.apply_academy = {}
      this.$emit('close')
      this.query.pageIndex = 1
    },
    open() {
      this.fetchList()
      this.Majorists()
      this.getAcademyList()
      this.majorDirect(this.detail.college_code, this.detail.major_code)
    },
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      params.year = this.year
      params.college_code = this.college_keyword
      params.major_code = this.apply_major.value
      params.academy_code = this.apply_academy.value
      if (params.creators) {
        this.position = params.creators = params.creators.join(',')
      }
      adjustAdminlist(params).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },

    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.creators && this.query.creators.length) {
        this.query.creators = this.query.creators.split(',').map((v) => {
          return Number(v)
        })
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query)
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      )
      if (params.creators) {
        params.creators = params.creators.filter((v) => v).join(',')
      }
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        })
    },
    handleToEdit(row) {
      this.editId = row.id
      this.editDialog = true
    },
    collegeChange(e) {
      if (e) {
        this.fetchMajor(e)
      }
      setTimeout(() => {
        this.fetchList(true)
      }, 500)
    },
    fetchMajor(college_code) {
      collegeMajorList({ college_code, isPaging: 0 }).then((res) => {
        this.majorList = res.list
      })
    },
    // majorChange(e) {
    //   if (e) {
    //     this.fetchAcademy(this.query.college_code, e)
    //   }
    //   setTimeout(() => {
    //     this.fetchList(true)
    //   }, 500)
    // },
    // fetchAcademy(college_code, major_code) {
    //   academyList({ college_code, major_code, isPaging: 0 }).then((res) => {
    //     this.academylist = res.list
    //   })
    // },
    handleToRemove(id) {
      this.$confirm('确定要删除此条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteAdjustAdmin({ id }).then((res) => {
          this.fetchList(true)
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.fileStyle {
  position: relative;

  margin-right: 5px;
  border-radius: 1px;
  padding: 6px 15px;
  color: #999999;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #999999;
}
::v-deep .el-upload-list {
  display: none !important;
}
.btBox {
  position: relative;
}
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.footer {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
